import makeStyles from '@mui/styles/makeStyles';
import colors from 'global/styles/colors';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  buttonRow: {
    flexDirection: 'row',
    display: 'flex',
    margin: `${theme.spacing(3)} 0`,
    alignItems: 'space-between',
  },
  button: {
    marginRight: theme.spacing(2),
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
  dropZone: {
    marginTop: theme.spacing(1),
  },
  diagContainer: {
    width: '80vw',
    height: '80vh',
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1),
      width: '100vw',
      height: '100vh',
    },
  },
  loader: {
    position: 'absolute',
    bottom: theme.spacing(8.5),
    width: '100%',
  },
  appBarTitle: {
    textAlign: 'center',
    width: '100%',
    marginRight: 40,
  },
  diagTitle: {
    padding: 0,
  },
  selectFiles: {
    position: 'absolute',
    top: theme.spacing(10),
    left: theme.spacing(4),
    zIndex: 100,
    [theme.breakpoints.down('md')]: {
      position: 'inherit',
      margin: 'auto',
    },
  },
  diagButtonContainer: {
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  diagButton: {},
  locationSelect: {
    width: '30%',
    marginLeft: 'auto',
    marginRight: theme.spacing(2),
  },
  photoPreviewGrid: {
    padding: `${theme.spacing(1)} !important`,
  },
  photoPreviewGridContainer: {
    width: 'inherit',
    margin: 0,
  },
}));

export const imageStyles = makeStyles((theme) => ({
  root: {
    width: '22%',
    margin: '1.5%',
    position: 'relative',

    '& button': {
      minWidth: 'auto',
    },
  },
  deleteBtn: {
    position: 'absolute',
    top: 5,
    right: 5,
  },
  rankContainer: {
    position: 'absolute',
    bottom: 0,
    height: 40,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  posRank: {
    color: colors.buttonSuccess,
    marginRight: theme.spacing(1),
  },
  negRank: {
    color: colors.redIcon,
    marginLeft: theme.spacing(1),
  },
}));
